import { Component, Input, ViewChild, ElementRef, Output, EventEmitter, OnInit } from '@angular/core';
import { HttpService } from '../../../../services/dataAccess.service';
import { CoreService } from '../../../../services/core.service';
import { PropertyData, HtmlBase, InseeModel, ListInseeQueovalValues, QueovalItem, BObjectModel, BObjectSummary, Person, QueovalDik, PropertyGroup, QResult } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IdNameBase, MyCompanyFilesAddStorage, MyCompanyFilesArbo, MyCompanyFilesAttribute, MyCompanyFilesCustomerUser, MyCompanyFilesInfoStoragePublisherDto, MyCompanyFilesModel, MyCompanyFilesQueovalAttribute } from '../../../../models/MyCompanyFiles/my-company-files.model';
import { Observable } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectMultipleChange, SelectMultipleComponent } from './select-multiple/select-multiple.component';
import { ToastService } from '../../../../toast';
import { AfterViewInit } from '@angular/core';

@Component({
  selector: 'q-input-my-company-files',
  templateUrl: './input-my-company-files.component.html',
  styleUrls: ['./input-my-company-files.component.css', '../../dynamictag.component.css']
})

export class InputMyCompanyFilesComponent extends BaseAddOnComponent implements OnInit{

  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  @Input('input') input: PropertyData;
  @Input('model') set SetModel(value: BObjectModel) {
    this.model = value;
  }

  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(true);

  public group: string;
  public storage: string;
  public model: BObjectModel;

  // #region CONSTRUCTEUR
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private modalService: NgbModal,
    private cd: ChangeDetectorRef,
    private toast: ToastService,
  ) { super(); }
  // #endregion

  public ngOnInit(): void {  }
  // #endregion

  // clic sur les boutons de la propriété du BO
  public OnButtonClicked(button: HtmlBase, content: any): void {
    switch (button.TypeModal) {
      //ouvre la modal de configuration des clients my company files
      case 'MODAL':
          //this.selectedStorage = '';
        this.group = '';
         

        //#region binding du bo modèle sur les propriétés id group et storage
        const keys = ['idMCFCLI', 'grMCFCLI'];
        keys.forEach((key: string) => {
          const summary: BObjectSummary[] = this.model.summary.filter((el: BObjectSummary) => {
            return el.ColumnName.toLocaleLowerCase() == key.toLocaleLowerCase() || el.ColumnsIds.includes(key)
          });
          if (summary && summary.length == 1) {
            const prop: PropertyData = this.model.Body.SelectedGroupsList[summary[0].IndexGroupsList].DataList[summary[0].IndexDataList];
            let index: number = prop.MainElementList.findIndex(element => element.ID == key);
            index = index == -1 ? 0 : index;
            switch (key) {
              case 'idMCFCLI':
                this.storage = prop.MainElementList[index].Value;
                break;
              case 'grMCFCLI':
                this.group = prop.MainElementList[index].Value;
                break;
            }
          }
        });
        //#endregion
        this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-bo-compte-client-sur-entite qmodalover' }).result.then((modalResult) => {
          switch (modalResult) {
            //  case 'SAVE': this.saveConfigSignature(); break;
            //  case 'CANCEL': this.closeConfigSignature(); break;
          }
        });
        break;
      //appel le comportement normal du clic bouton sur un dynamictag
      default:
        this.navig.emit(button);
    }
  }

  public Save(modal: any, response: MyCompanyFilesModel): void {
    //#region affectation des nouvelles valeurs de façon dynamique dans le BO
    const values = new Map();
    values.set('idMCFCLI', response.IdStorage);
    values.set('grMCFCLI', response.IdGroup);
    const keys = ['idMCFCLI', 'grMCFCLI'];
    keys.forEach((key: string) => {
      const summary: BObjectSummary[] = this.model.summary.filter((el: BObjectSummary) => {
        return el.ColumnName.toLocaleLowerCase() == key.toLocaleLowerCase() || el.ColumnsIds.includes(key)
      });
      if (summary && summary.length == 1) {
        const prop: PropertyData = this.model.Body.SelectedGroupsList[summary[0].IndexGroupsList].DataList[summary[0].IndexDataList];
        let index: number = prop.MainElementList.findIndex(element => element.ID == key);
        index = index == -1 ? 0 : index;
        prop.MainElementList[index].Value = values.get(key);
        if (prop && prop.MainElementList[index].SelectOptionsList && prop.MainElementList[index].SelectOptionsList.length > 0) {
          prop.MainElementList[index].SelectOptionsList.forEach((option: QueovalItem) => {
            if (option.Value.toLocaleLowerCase() == prop.MainElementList[index].Value.toLocaleLowerCase()) {
              option.Selected = true;
            } else {
              option.Selected = false;
            }
          })
        }
      }
    });
    //#endregion
    modal.close('SAVE');
  }
}
